export default __webpack_public_path__ + "static/media/cover_1.0cb8e057.jpg";